import styled from 'styled-components'
import {
  space,
  position,
  color,
  typography,
  border,
  layout,
  flexbox,
  shadow,
  grid,
} from 'styled-system'
import A from '@components/A'

export const Container = styled.div`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${shadow}
  ${grid}
`

export const StyledH4 = styled.h4`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${shadow}
  ${grid}
`

export const StyledImage = styled.img`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${shadow}
  position: absolute;
  object-fit: cover;
  object-position: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`

export const StyledImageContainer = styled.div`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${shadow}
  position: relative;
`

export const StyledALink = styled(A)`
  text-transform: initial;
  letter-spacing: 0.5px;
  color: #b4a06e;
  font-size: 16px;
  &:hover {
    text-decoration: underline;
  }
`
